import {
  updateFormatRecipeLabelPath,
  updateProteinScoreRecipePath,
  updateForLabelRecipePath,
} from "routes";
/* global jQuery, recipe_label */

let saveEnabled = true;

export const canSave = () => {
  return !!document.querySelector("#submit-recipe-show-data");
};

export const recipeId = () => {
  if (window.recipe_id) {
    return window.recipe_id;
  }
  if (window.recipe_label && window.recipe_label.recipe_id) {
    return window.recipe_label.recipe_id;
  }
  // Fallback to parsing from URL for regular routes
  return window.location.pathname.split("/recipes/")[1];
};

export const setSaveEnabled = (enabled = true) => {
  saveEnabled = enabled;
};

export const saveLabel = async (attributes, recipeLabelId = recipe_label.id) => {
  if (!(canSave() && saveEnabled)) {
    return false;
  }

  window.__recipeLabelWritesInFlight = (window.__recipeLabelWritesInFlight || 0) + 1;
  try {
    await jQuery.ajax(updateFormatRecipeLabelPath(recipeLabelId), {
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify({ recipe_label: attributes }),
      dataType: "script",
    });
    return true;
  } catch (_) {
    return false;
  } finally {
    window.__recipeLabelWritesInFlight = Math.max(0, (window.__recipeLabelWritesInFlight || 1) - 1);
  }
};

export const saveRecipe = async (attributes, recipe = recipeId()) => {
  if (!(canSave() && saveEnabled)) {
    return false;
  }

  let endpoint;
  if (recipe != recipeId()) {
    // on a label with multiple recipes
    endpoint = updateForLabelRecipePath(recipe, { parent: recipeId() });
  } else {
    endpoint = updateForLabelRecipePath(recipe);
  }

  try {
    await jQuery.ajax(endpoint, {
      type: "PUT",
      contentType: "application/json",
      data: JSON.stringify({ recipe: attributes }),
      dataType: "script",
    });
    return true;
  } catch (_) {
    return false;
  }
};

export const saveProteinScore = (score) => {
  jQuery.ajax(updateProteinScoreRecipePath(recipeId()), {
    type: "PUT",
    contentType: "application/json",
    data: JSON.stringify({ protein_score: score }),
    dataType: "script",
  });
};
